import { Stub, VStack } from '@direct-frontend/components';
import { CharacteristicItemStub, type CharacteristicItemStubProps } from '@/shared/components/CharacteristicsList';
import { DrawerBottomFixed, DrawerButtonStub } from '@/shared/components/Drawer';
import styles from './OrderVariantsEditModal.module.css';

const MAX_CHARACTERISTICS_FOR_STUB = 3;

const CHARACTERISTIC_STUB_PROPS_MAPPING: Map<number, CharacteristicItemStubProps> = new Map([
    [0, { length: 5, chipHeight: 32, chipWidth: 80, chipBorderRadius: '8' }],
    [1, { length: 4, chipHeight: 32, chipWidth: 32, chipBorderRadius: 'round' }],
    [2, { length: 4, chipHeight: 65, chipWidth: 84, chipBorderRadius: '8' }],
]);

export const OrderVariantsEditModalStub = ({ length }: { length: number }) => (
    <VStack>
        <VStack className={styles.scroll}>
            <Stub height={32} width={200} />

            <VStack gap="20">
                {Array.from({ length: Math.min(length, MAX_CHARACTERISTICS_FOR_STUB) }).map((_, index) => {
                    const props = CHARACTERISTIC_STUB_PROPS_MAPPING.get(index);

                    if (!props) {
                        return null;
                    }

                    return <CharacteristicItemStub key={index} {...props} />;
                })}
            </VStack>
        </VStack>

        <VStack className={styles.button}>
            <DrawerBottomFixed isSticky>
                <DrawerButtonStub height={56} />
            </DrawerBottomFixed>
        </VStack>
    </VStack>
);
